import { createTheme } from "@mui/material/styles";

import { colors, fontFamily, fontSizes, fontWeights, radii } from "theme/themeConstants";

const createAppTheme = () =>
  createTheme({
    palette: {
      primary: {
        main: colors.primary,
        dark: colors.primaryDark,
      },
      error: {
        main: colors.error,
      },
      text: {
        primary: colors.textPrimary,
        secondary: colors.textSecondary,
      },
      background: {
        default: colors.bodyBg,
        paper: colors.cardBg,
      },
      action: {
        disabled: colors.disabledText,
        disabledBackground: colors.disabledBg,
      },
    },
    typography: {
      fontFamily: fontFamily.primary,
    },
    shape: {
      borderRadius: Number.parseInt(radii.md, 10),
    },
    components: {
      MuiTextField: {
        defaultProps: {
          fullWidth: true,
          variant: "outlined",
          size: "small",
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: fontSizes.md,
            fontWeight: fontWeights.semibold,
            color: colors.textLabel,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: radii.md,
            backgroundColor: colors.cardBg,
            fontSize: fontSizes.base,
            color: colors.textPrimary,
            "& fieldset": {
              borderColor: colors.border,
            },
            "&:hover fieldset": {
              borderColor: colors.textMuted,
            },
            "&.Mui-focused fieldset": {
              borderColor: colors.primary,
              boxShadow: `0 0 0 3px ${colors.primaryFocusRing}`,
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginLeft: 0,
            fontSize: fontSizes.xs,
          },
        },
      },
    },
  });

export default createAppTheme;
